import Inquiry from 'app/shared/model/Inquiry';
import Listing from 'app/shared/model/Listing';

const LeadsDetails = ({
    excelFilename = '',
    inquiry = {},
    listing = {},
    phoneCallsByGuid = {},
} = {}) => ({
    excelFilename: String(excelFilename),
    inquiry: Inquiry(inquiry),
    listing: Listing(listing),
    phoneCallsByGuid: Object(phoneCallsByGuid),
});

export default LeadsDetails;
